/*
 * Marquee
 *   - Reads a single .marquee__set and clones it to fill 2× viewport width
 *   - Animates the track with requestAnimationFrame + translate3d (GPU)
 *   - Pauses on hover, handles resize
 *   - Speed selected via variant class: marquee--slow | marquee--normal | marquee--fast
 */

const SPEEDS_PX_PER_SEC = {
    slow:   30,
    normal: 50,
    fast:   80,
};

function initOne(marquee) {
    if (marquee.dataset.wired === '1') return;
    marquee.dataset.wired = '1';

    const track = marquee.querySelector('.marquee__track');
    if (!track) return;

    const firstSet = track.querySelector('.marquee__set');
    if (!firstSet) return;

    const variant = marquee.classList.contains('marquee--slow') ? 'slow'
                  : marquee.classList.contains('marquee--fast') ? 'fast'
                  : 'normal';
    const speed = SPEEDS_PX_PER_SEC[variant];

    let offset   = 0;
    let lastTime = 0;
    let setWidth = 0;
    let running  = true;

    const measure = () => { setWidth = firstSet.offsetWidth; };

    const ensureFill = () => {
        measure();
        if (!setWidth) return;
        const needed  = Math.ceil((window.innerWidth * 2) / setWidth) + 1;
        const current = track.querySelectorAll('.marquee__set').length;
        for (let i = current; i < needed; i++) {
            const clone = firstSet.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
        }
    };

    ensureFill();
    measure();

    const tick = (timestamp) => {
        if (!running) return;
        if (!lastTime) lastTime = timestamp;
        const delta = (timestamp - lastTime) / 1000;
        lastTime = timestamp;
        offset += speed * delta;
        if (setWidth && offset >= setWidth) offset -= setWidth;
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
        requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { ensureFill(); measure(); }, 200);
    });
}

export function initMarquees() {
    document.querySelectorAll('.js-marquee').forEach(initOne);
}
